const SolidLine01Icon = /*#__PURE__*/ [
  ["path", { d: "M2.5 12L21.5002 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { SolidLine01Icon as default };
//# sourceMappingURL=SolidLine01Icon.js.map
